import {
    UPDATE_PROGRESS
} from '../../actions/progressActions';

const ProgressReducer = (state = 0, action) => {
    switch (action.type) {
        case UPDATE_PROGRESS:
            if (!action.promptId) {
                return 100;
            }

            const { promptId, promptQueue, assessmentType, allPromptIds } = action;

            if (assessmentType === 'dependentOnRoot' && promptQueue.length === 1) {
                const placeholderValue = (1 / allPromptIds.length) * 100;
                return placeholderValue;
            }

            const totalPrompts = promptQueue.length + 1; //include results page into count
            const promptSequenceNum = promptQueue.indexOf(promptId) + 1;
            const progress = (promptSequenceNum / totalPrompts) * 100

            return progress;

        default:
            return state;
    }
};

export default ProgressReducer;